import { getMyAccountId } from "../utils/config";

export const addOrMergeOrderItem = ({
    items,
    setItems,
    product,
    qtyToAdd,
    user,
    addToCartSilent, // unused: setItems already updates CartContext
    updateCartItem,  // unused: setItems already updates CartContext
}) => {
    const exists = items.find((x) => x.code === product.productId);
    const MYACCOUNT_ID = getMyAccountId();

    if (exists) {
        const newQty = exists.qty + qtyToAdd;
        const subtotalCents = Math.round(Math.round(exists.price * 10000) * newQty / 100);
        const newSubtotal = (subtotalCents / 100).toFixed(2);
        const newTax = exists.payTax
            ? (Math.round(subtotalCents * (user.porcentaje / 100)) / 100).toFixed(2)
            : "0.00";

        const updated = items.map((x) =>
            x.code === product.productId
                ? { ...x, qty: newQty, subtotal: newSubtotal, tax: newTax }
                : x
        );
        setItems(updated);
        return;
    }

    const subtotalCents = Math.round(Math.round(product.unitPrice * 10000) * qtyToAdd / 100);
    const st = (subtotalCents / 100).toFixed(2);
    const taxCalc = product.payTax
        ? (Math.round(subtotalCents * (user.porcentaje / 100)) / 100).toFixed(2)
        : "0.00";

    const newItem = {
        img: `https://www.ultra-erp.pro/products/${MYACCOUNT_ID}/${product.productId}.jpg`,
        idProduct: product.idProduct,
        code: product.productId,
        description: product.productName,
        notes: null,
        price: product.unitPrice,
        qty: qtyToAdd,
        subtotal: st,
        payTax: product.payTax,
        tax: taxCalc,
        service: product.service,
    };

    setItems((prev) => [...prev, newItem]);
};
